const runtimeConfig = window.__STOP_CONFIG__ || {};
const STOP_APP_BASENAME = runtimeConfig?.URL?.STOP_APP_BASENAME || "/";

function isHttpUrl(value) {
  return /^https?:\/\//i.test(String(value || ""));
}

const config = {
  URL: {
    STOP_APP_URL:
      runtimeConfig?.URL?.STOP_APP_URL || window.location.origin + STOP_APP_BASENAME,
    STOP_APP_URL_BACK:
      isHttpUrl(runtimeConfig?.URL?.STOP_APP_URL_BACK) ? runtimeConfig?.URL?.STOP_APP_URL_BACK : window.location.origin + STOP_APP_BASENAME + runtimeConfig?.URL?.STOP_APP_URL_BACK,
    STOP_APP_URL_AFIP:
      isHttpUrl(runtimeConfig?.URL?.STOP_APP_URL_AFIP) ? runtimeConfig?.URL?.STOP_APP_URL_AFIP : window.location.origin + runtimeConfig?.URL?.STOP_APP_URL_AFIP,
    STOP_APP_URL_BH:
      isHttpUrl(runtimeConfig?.URL?.STOP_APP_URL_BH) ? runtimeConfig?.URL?.STOP_APP_URL_BH : window.location.origin + STOP_APP_BASENAME + runtimeConfig?.URL?.STOP_APP_URL_BH,
    STOP_APP_BASENAME,
    BASENAME: STOP_APP_BASENAME // Se mantiene por compatibilidad
  },
  version: runtimeConfig?.version || null,
  AUTH: {
    CAPTCHA: {
      PROVIDER: (
        runtimeConfig?.AUTH?.CAPTCHA?.PROVIDER || "none"
      ).toLowerCase(),
      SITEKEY: runtimeConfig?.AUTH?.CAPTCHA?.SITEKEY || "",
    },
  },
  GOOGLE_MAP: {
    GOOGLE_API_KEY: runtimeConfig?.GOOGLE_MAP?.GOOGLE_API_KEY || "",
    PLACES: ["places", "geometry"],
  },
};

export default config;

/* const {
  REACT_APP_STOP_APP_URL,
  REACT_APP_STOP_APP_URL_BACK,
  REACT_APP_STOP_APP_URL_BH,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_N4_AUTH_CAPTCHA_PROVIDER,
  REACT_APP_N4_AUTH_CAPTCHA_SITEKEY,
  REACT_APP_STOP_APP_URL_AFIP,
  REACT_APP_BASENAME,
} = process.env;

const config = {
  URL: {
    STOP_APP_URL: REACT_APP_STOP_APP_URL || window.location.origin + REACT_APP_BASENAME,
    STOP_APP_URL_BACK: REACT_APP_STOP_APP_URL_BACK || window.location.origin + REACT_APP_BASENAME + '/backend',
    STOP_APP_URL_AFIP: REACT_APP_STOP_APP_URL_AFIP || window.location.origin + '/afip-task',
    STOP_APP_URL_BH: REACT_APP_STOP_APP_URL_BH || window.location.origin + REACT_APP_BASENAME + '/bh/v1.0.0',
    BASENAME: REACT_APP_BASENAME
  },
  AUTH: {
    CAPTCHA: {
      PROVIDER: (REACT_APP_N4_AUTH_CAPTCHA_PROVIDER || "none").toLowerCase(),
      SITEKEY: REACT_APP_N4_AUTH_CAPTCHA_SITEKEY || "",
    },
  },
  GOOGLE_MAP: {
    GOOGLE_API_KEY: REACT_APP_GOOGLE_MAPS_API_KEY,
    PLACES: ["places", "geometry"],
  },
};

export default config; */